import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isEditPlanzoneSettingsRequestFailure({ uuid }) {
      const req = getState().find(({ planzone }) => planzone.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isEditPlanzoneSettingsRequestPending({ uuid }) {
      const req = getState().find(({ planzone }) => planzone.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isEditPlanzoneSettingsRequestSuccess({ uuid }) {
      const req = getState().find(({ planzone }) => planzone.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
